import React from 'react';
import PropTypes from 'prop-types';

// REDUX
import { useDispatch } from 'react-redux';
import { openContactSidebar } from 'store/v1/ui/ui.actions.js';

//COMPONENTS
import { ContactPageLink } from 'v1/components/shared/byModel/Resource/ContactPageLink/ContactPageLink';
import { ResourceMeta } from 'v1/components/shared';
import { Grid, ResourceBadgeIcon, GridCell } from 'v1/components/shared';

// IMPORTS
import classnames from 'classnames';

import './ResourceTitle.scss';

import { ResourceNameWithPronouns } from 'v5/patterns/resource/ResourceNameWithPronouns';
import { myServices } from 'v5/services/services.connected.app';

const ResourceTitle = ({
  className,
  truncate,
  resource = {},
  navigateToMethod,
  onSelect,
  hideRole
}) => {
  const dispatch = useDispatch();
  const slugAppScope = myServices.appScopeService.useSlugAppScope();

  const pronounsProps = {
    services: myServices,
    pronounsOptionId: resource.pronouns_option_id ?? null,
    resourceTypeId: resource.resource_type_id ?? null
  };
  const nameCls = classnames('ResourceTitle-name text-13-700', {
    trunc: truncate
  });

  function renderButtonContent() {
    return (
      <ResourceNameWithPronouns
        {...pronounsProps}
        name={resource.full_name}
        className={nameCls}
      />
    );
  }
  function renderPageRoute() {
    return (
      <ContactPageLink
        contactId={resource.id}
        className={classnames('link', nameCls)}
      >
        <ResourceNameWithPronouns
          {...pronounsProps}
          name={resource.full_name}
        />
      </ContactPageLink>
    );
  }
  function renderSidebarRoute() {
    return (
      <div
        onClick={() => dispatch(openContactSidebar(resource, slugAppScope))}
        className="ContactName-SidebarHint"
      >
        <ResourceNameWithPronouns
          {...pronounsProps}
          name={<span className={nameCls}>{resource.full_name}</span>}
        />
        <img
          data-tip="Quick View Contact"
          className="ContactName-SidebarHint-icon"
          src="/images/icon_contact_sidebar_hint.svg"
          alt=""
        />
      </div>
    );
  }
  function renderFunctionRoute() {
    return (
      <div onClick={() => onSelect(resource)}>{renderButtonContent()}</div>
    );
  }
  function renderName() {
    switch (navigateToMethod) {
      case 'PAGE':
        return renderPageRoute();
      case 'SIDEBAR':
        return renderSidebarRoute();
      case 'FUNCTION':
        return renderFunctionRoute();
      default:
        return renderButtonContent();
    }
  }
  return (
    <Grid vcenter className={classnames('ResourceTitle', className)}>
      <GridCell width="auto">
        <ResourceBadgeIcon resource={resource} />
      </GridCell>
      <GridCell>
        <div className={classnames('ResourceTitle-titles', 'tailwind-root')}>
          {renderName()}
          <ResourceMeta hideRole={hideRole} resource={resource} />
        </div>
      </GridCell>
    </Grid>
  );
};

ResourceTitle.propTypes = {
  className: PropTypes.string,
  truncate: PropTypes.bool,
  resource: PropTypes.object,
  navigateToMethod: PropTypes.oneOf(['PAGE', 'SIDEBAR', 'FUNCTION', false]),
  onSelect: PropTypes.func
};

ResourceTitle.defaultProps = {
  truncate: true,
  navigateToMethod: 'PAGE'
};

export default ResourceTitle;
